export default{
    methods:{
         // Generic overlap-based detection (works for horizontal or vertical layouts)
    handle_scroll() {
    const container = this.$refs.carousel;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const children = Array.from(container.querySelectorAll('.form-wrapper'));
    if (!children.length) return;

    // decide if scroll is vertical or horizontal by comparing scrollHeight vs clientHeight
    const isVertical = container.scrollHeight > container.clientHeight;

    let bestIndex = this.current_section_index || 0;
    let bestRatio = 0;

    children.forEach((child, i) => {
      const rect = child.getBoundingClientRect();
      let overlap = 0;
      const size = isVertical ? rect.height : rect.width;

      if (isVertical) {
        const top = Math.max(rect.top, containerRect.top);
        const bottom = Math.min(rect.bottom, containerRect.bottom);
        overlap = Math.max(0, bottom - top);
      } else {
        const left = Math.max(rect.left, containerRect.left);
        const right = Math.min(rect.right, containerRect.right);
        overlap = Math.max(0, right - left);
      }

      const ratio = size > 0 ? overlap / size : 0;
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestIndex = i;
      }
    });

    // require a meaningful presence (15%) to switch active index to avoid flicker
    if (bestRatio > 0.15 && bestIndex !== this.current_section_index) {
      this.current_section_index = bestIndex;
    }
    },

    // Add this method to your methods object
    scroll_to_section_centered(index) {
      const container = this.$refs.carousel;
      if (!container) return;

      const targetSection = container.querySelector(`.form-wrapper[data-index="${index}"]`);
      if (!targetSection) return;

      // Get container and target dimensions
      const containerRect = container.getBoundingClientRect();
      const targetRect = targetSection.getBoundingClientRect();

      // Calculate scroll position to center the section
      const scrollLeft = targetRect.left - containerRect.left + container.scrollLeft -
                        (containerRect.width - targetRect.width) / 2;

      // Smooth scroll to centered position
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
        });

      // Update current section index
      this.current_section_index = index;

    },

     scroll_to_section(index) {
      const container = this.$refs.carousel;
      if (container) {
        this.scroll_to_section_centered(index);
      }
    },

    observe_sections() {
      if (!this.$refs.carousel) return;

      // cleanup previous observer if any
      if (this._observer) {
        try { this._observer.disconnect(); } catch (e) { /* ignore */ }
        this._observer = null;
      }

      const options = {
        root: this.$refs.carousel,
        threshold: [0.25, 0.5, 0.75]
      };

      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const idx = Number(entry.target.dataset.index);
          if (!Number.isNaN(idx) && entry.intersectionRatio >= 0.5) {
            this.current_section_index = idx;
          }
        });
      }, options);

      const sections = this.$refs.carousel.querySelectorAll('.form-wrapper');
      if (!sections || sections.length === 0) return;

      sections.forEach((section, index) => {
        section.dataset.index = index;
        this._observer.observe(section);
      });
    },

    // attach / detach scroll listeners (call after DOM is ready)
    attachCarouselListeners() {
      const carousel = this.$refs.carousel;
      if (!carousel) return;

      // debounce helpers
      this._scrollRaf = null;
      this._touchTimeout = null;
      this._resizeTimeout = null;

      // scroll (RAF) and touchend fallback
      const onScroll = () => {
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
        this._scrollRaf = requestAnimationFrame(() => {
          this.handle_scroll();
          this._scrollRaf = null;
        });
      };

      const onTouchEnd = () => {
        if (this._touchTimeout) clearTimeout(this._touchTimeout);
        this._touchTimeout = setTimeout(() => {
          this.handle_scroll();
          this._touchTimeout = null;
        }, 80); // small delay to allow inertia to finish
      };

      const onResize = () => {
        if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
        this._resizeTimeout = setTimeout(() => {
          this.handle_scroll();
          this._resizeTimeout = null;
        }, 120);
      };

      // keep references so we can remove later
      this._carouselListeners = { onScroll, onTouchEnd, onResize };

      carousel.addEventListener('scroll', onScroll, { passive: true });
      carousel.addEventListener('touchend', onTouchEnd, { passive: true });
      window.addEventListener('resize', onResize);
    },

     // cleanup (call in beforeUnmount)
    detachCarouselListeners() {
      const carousel = this.$refs.carousel;
      if (!carousel || !this._carouselListeners) return;
      const { onScroll, onTouchEnd, onResize } = this._carouselListeners;
      carousel.removeEventListener('scroll', onScroll);
      carousel.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('resize', onResize);

      if (this._scrollRaf) { cancelAnimationFrame(this._scrollRaf); this._scrollRaf = null; }
      if (this._touchTimeout) { clearTimeout(this._touchTimeout); this._touchTimeout = null; }
      if (this._resizeTimeout) { clearTimeout(this._resizeTimeout); this._resizeTimeout = null; }

      this._carouselListeners = null;
    }

    }
}